import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
//import DriversComponent from "../DriversOld/DriversComponent";
import "./SettlementsDriverPOC.scss";
import Sidebar from "app/views/commonComponents/Sidebar/Sidebar";
import { Container } from "reactstrap";
import Breadcrumbs from "app/views/commonComponents/Breadcrumb/Breadcrumbs";
import Title from "app/views/commonComponents/Title/Title";
import backRightArrow from "../../../../../../assets/images/poc/backRightArrow.svg";
import userIcon from "../../../../../../assets/images/poc/userIcon.svg";
import { Link } from "react-router-dom";
import QuickActionsDropdown from "app/views/commonComponents/QuickActionsDropdown/QuickActionsDropdown";
import driverProfile from "../../../../../../assets/images/drivers/driverProfile.svg";
import accidents from "../../../../../../assets/images/drivers/accidents.svg";
import calendarRemove from "../../../../../../assets/images/drivers/calendarRemove.svg";
import moneys from "../../../../../../assets/images/drivers/moneys.svg";
import presentionChart from "../../../../../../assets/images/drivers/presentionChart.svg";
import star from "../../../../../../assets/images/drivers/star.svg";
import previousArrow from "../../../../../../assets/images/poc/previousArrow.svg";
import nextArrow from "../../../../../../assets/images/poc/nextArrow.svg";
import previousGreyArrow from "../../../../../../assets/images/poc/previousGreyArrow.svg";
import nextGreyArrow from "../../../../../../assets/images/poc/nextGreyArrow.svg";
import grossArrowDown from "../../../../../../assets/images/poc/grossArrowDown.svg";
import enterArrow from "../../../../../../assets/images/poc/enterArrow.svg";
import DriversTablePOC from "../../TablePOC/TablePOC";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment-timezone";
import Icon from "app/views/commonComponents/Icon/Icon";
import AdditionalPaymentTable from "../AdditionalPaymentTable/AdditionalPaymentTable";
import {
  getSettelmentDriverDetailsData,
  getSettlementsListData,
} from "app/apiServices/apiServices";
const SettlementsDriverPOC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [maxTableHeight, setMaxTableHeight] = useState(0);
  const [currentDriverIndex, setCurrentDriverIndex] = useState(0); // Track the index of the currently displayed driver
  const [
    settelmentsDriverDetailsOriginalData,
    setSettelmentsDriverDetailsOriginalData,
  ] = useState([]);
  const [settelmentsListOriginalData, setSettlementsListOriginalData] =
    useState([]);
  const [loadDetailsTableDataNew, setLoadDetailsTableDataNew] = useState([]);
  const [driverName, setDriverName] = useState("");
  const [newDriverID, setNewDriverId] = useState("");
  const [statementDate, setStatementDate] = useState("");
  const history = useHistory();
  const { driverID, uploadId, settlementDate } = useParams();
  const breadcrumbItems = [
    { title: "Weekly Settlements", link: "/settlement" },
    {
      title: statementDate,
      link: `/settlement/${settlementDate}/${uploadId}`,
    },
    {
      title: driverName,
    },
  ];
  const driverData = [
    { icon: driverProfile, values: "19", title: "Loads" },
    //{ icon: userTag, values: "23,435", title: "On Fleet Drivers" },
    { icon: star, values: "$10,978", title: "Revenue" },
    { icon: accidents, values: "$2,978", title: "Other Revenue" },
    { icon: calendarRemove, values: "$1,978", title: "Deduction" },
    { icon: moneys, values: "$30,544", title: "Net Pay" },
    //{ icon: presentionChart, values: "86.3%", title: "Avg. RPM" },
    // Add more data items as needed
  ];
  const tabsData = [
    { id: 0, label: "Profile" },
    { id: 1, label: "Loads" },
    { id: 2, label: "Driver History" },

    // Add more tabs as needed
  ];
  const settlementsTableDataALL = settelmentsListOriginalData.map((driver) => ({
    driverID: driver.driver_id,
    driverName: driver.driver_name,
    loadsDelivered: driver.loads_delivered.toLocaleString(),
    milesLoaded: driver.loaded_miles.toLocaleString(),
    rpm: driver.rpm
      ? `$${driver.rpm.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "$0.00", // Formatting rpm with 2 decimal places
    totalRevenue: `$${driver.total_revenue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`,
    totalOtherRevenue: `$${driver.other_revenue_amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} •  ${driver.other_revenue_count.toLocaleString()}`,
    totalDeduction: `$${driver.deduction_amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} • ${driver.deduction_count.toLocaleString()}`,
    netPay: `$${driver.net_pay.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`,
    status: capitalizeFirstLetter(driver.status),
    // settlementDate: settlementDate,
    // uploadId: uploadId,
  }));

  // Function to capitalize the first letter of a string
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  console.log("settlementsTableDataALL", settlementsTableDataALL);
  //console.log("settlementsTableDataALL1", settlementsTableDataALL[0]);
  const settlementsTableHeaders = {
    driverID: "Driver Id.",
    driverName: "Driver Name",
    totalLoad: "Loads",
    milesLoaded: "Loaded Miles",
    rpm: "RPM",
    totalRevenue: "Load Revenue",
    totalOtherRevenue: "Other Revenue",
    totalDeduction: "Deductions",
    netPay: "Net Pay",
    status: "Status",
  };
  const settlementsTableDataAPI =
    settelmentsDriverDetailsOriginalData &&
    settelmentsDriverDetailsOriginalData.map((item, index) => {
      return {
        driverID: item.driver_id,
        driverName: item.driver_name,
        totalLoad: item.loads_delivered.toLocaleString(),
        milesLoaded: item.loaded_miles.toLocaleString(),
        rpm: item.rpm
          ? `$${item.rpm.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "$0.00",
        totalRevenue: `$${item.total_revenue.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        totalOtherRevenue: `$${item.other_revenue_amount.toLocaleString(
          "en-US",
          { minimumFractionDigits: 2, maximumFractionDigits: 2 }
        )}  •  ${item.other_revenue_count.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        totalDeduction: `$${item.deduction_amount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })} •  ${item.deduction_count.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        netPay: item.net_pay
          ? `$${item.net_pay.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "$0.00",
        status: item.status ? capitalizeFirstLetter(item.status) : "", // Assuming you have a function to determine the status
      };
    });
  const settlementsTableData = [
    {
      driverID: "KH4235",
      driverName: "Black, Marvin",
      totalLoad: "3",
      milesLoaded: "300",
      rpm: "$30.25",
      totalRevenue: "$8,729.16",
      totalOtherRevenue: "$229.00    •    2",
      totalDeduction: "$229.00    •    3",
      netPay: "$229.00 ",
      status: "Review",
    },
  ];
  const loadsTableHeaders = {
    loadNo: "Load No.",
    date: "Date",
    originDestination: "Origin & Destination",
    milesLoaded: "Loaded Miles",
    rpm: "RPM",
    itemisedTotal: "Itemized Total",
    gross: "%Gross",
    contractorAmount: "Contractor Amount",
  };
  const loadsOriginalArrays = settelmentsDriverDetailsOriginalData.map((item) =>
    item.loads ? item.loads : ""
  );
  console.log("loadsOriginalArrays", loadsOriginalArrays);
  const loadsTableData = loadsOriginalArrays
    .map((loadArray) => {
      return loadArray.map((item, index) => {
        //console.log("item.pay_description", item.pay_description);
        const loadedMilesWithCommas = parseInt(
          item.loaded_miles
        ).toLocaleString("en");
        const originalDateString = item.date;
        let originalDate = moment.utc(originalDateString);
        const month = moment(originalDate).format("MMM");
        const day = moment(originalDate).format("DD");
        const year = moment(originalDate).year();
        const formattedDate = `${month} ${day}, ${year}`;
        return {
          loadNo: item.load_id,
          date: formattedDate,
          originDestination: `${item.origin} - ${item.destination}`,
          milesLoaded: loadedMilesWithCommas,
          // payDescriptions: item.pay_description,
          rpm: item.rpm
            ? `$${item.rpm.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`
            : null,
          itemisedTotal: `$${item.total_revenue.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          gross: grossArrowDown, // You need to specify how to calculate this
          contractorAmount: `$${item.contractor_amount.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
        };
      });
    })
    .flat();
  const loadDetailsTableHeaders = {
    loadNo: "Load No.",
    date: "Date",
    originDestination: "Origin & Destination",
    payDescription: "Pay Description",
    milesLoaded: "Loaded Miles",
    rpm: "RPM",
    milesLoaded2: "Loaded Miles",
    rpm2: "RPM",
    //milesLoade3: "Loaded Miles",
    rpm3: "RPM",
    itemisedTotal: "Itemized Total",
    gross: "%Gross",
    contractorAmount: "Contractor Amount",
  };
  const loadsObjects = loadsOriginalArrays.flat().map((loadArray, index) => ({
    load_id: index == 0 ? enterArrow : "",
    date: "",
    originDestination: loadArray.description,
    loaded_miles: "",
    rpm: "",
    total_revenue: loadArray.total_revenue,
    gross: loadArray.gross_percentage,
    contractor_amount: loadArray.driver_total_revenue,
    pay_description: loadArray.pay_description,
  }));
  console.log("loadsOriginalArrays2", loadsObjects);
  const loadSubTableData = loadsObjects.map((item) => item.pay_description);
  // Extract each array of objects
  for (let i = 0; i < loadSubTableData.length; i++) {
    console.log(`loadDetailsArray2 ${i}:`, loadSubTableData[i]);
  }

  console.log("loadsTableData", loadsTableData);
  const subtotalLoads = loadsOriginalArrays
    .flatMap((loadArray) => loadArray.map((item) => item.contractor_amount))
    .reduce((acc, curr) => acc + curr, 0);
  loadsTableData.push({
    loadID: "",
    date: "",
    originDestination: "",
    milesLoaded: "",
    rpm: "", // Assuming you want 2 decimal places for RPM
    itemisedTotal: "", // Assuming this field is not provided in the data
    grossPercenatge: "Sub Total", // Assuming gross_percentage is a percentage
    contractorAmount: `$${subtotalLoads.toLocaleString("en-US", {
      maximumFractionDigits: 2,
    })}`,
  });
  ////////////////
  const additionalArrays = settelmentsDriverDetailsOriginalData.map((item) =>
    item.other_income_list ? item.other_income_list : ""
  );
  const additionalPaymentTableHeaders = {
    additionalPaymentDescriptions: "Additional Payment Descriptions",
    date: "Date",
    amount: "Amount",
    grossPercenatge: "%Gross",
    contractorAmount: "Contractor Amount",
  };
  const additionalPaymentTableData = additionalArrays.flatMap(
    (innerArray, indexArray) =>
      innerArray.map((item, index) => {
        console.log("itemArray", item);
        const originalDateString = item.statement_date;
        let originalDate = moment.utc(originalDateString);
        const month = moment(originalDate).format("MM");
        const day = moment(originalDate).date();
        const year = moment(originalDate).year();
        const formattedDate = `${month}-${day}-${year}`;
        // if (
        //   indexArray === additionalArrays.length - 1 &&
        //   index === innerArray.length - 1
        // ) {
        //   // Only show contractorAmount for the last row
        //   return {
        //     additionalPaymentDescriptions: "",
        //     date: "", // Use the formatted date here
        //     amount: "",
        //     grossPercenatge: `Sub Total`,
        //     contractorAmount: `$${item.contractor_amount.toLocaleString(
        //       "en-US",
        //       {
        //         maximumFractionDigits: 2,
        //       }
        //     )}`,
        //   };
        // } else {
        return {
          additionalPaymentDescriptions: item.description,
          //date: formattedDate, // Use the formatted date here
          amount: `${item.amount.toLocaleString("en-US", {
            maximumFractionDigits: 2,
          })}`,
          //grossPercenatge: `${item.gross_percentage}%`,
          // contractorAmount: `$${item.contractor_amount.toLocaleString("en-US", {
          //   maximumFractionDigits: 2,
          // })}`,
        };
        // }
      })
  );
  const additionalPaymentDescriptionTableData = additionalArrays.flatMap(
    (innerArray, indexArray) =>
      innerArray.map((item, index) => {
        console.log("itemArray", item);
        const originalDateString = item.statement_date;
        let originalDate = moment.utc(originalDateString);
        const month = moment(originalDate).format("MM");
        const day = moment(originalDate).date();
        const year = moment(originalDate).year();
        const formattedDate = `${month}-${day}-${year}`;
        return {
          id: item._id,
          additionalPaymentDescriptions: item.description,
          amount: `${item.contractor_amount.toLocaleString("en-US", {
            maximumFractionDigits: 2,
          })}`,
        };
        // }
      })
  );
  console.log("additionalPaymentTableData", additionalPaymentTableData);
  // Create the subtotal row
  const subtotalAdditionalRow = {
    additionalPaymentDescriptions: "",
    date: "", // Use the formatted date here
    amount: "",
    grossPercenatge: "Sub Total",
    contractorAmount: `$${additionalArrays
      .flat()
      .reduce((total, item) => total + item.contractor_amount, 0)
      .toLocaleString("en-US", { maximumFractionDigits: 2 })}`,
  };
  // Add the subtotal row to the end of the table data
  // additionalPaymentTableData.push(subtotalAdditionalRow);
  const deductionArrays = settelmentsDriverDetailsOriginalData.map((item) =>
    item.deductions_list ? item.deductions_list : ""
  );
  const deductionDescriptionTableHeaders = {
    deductionDescription: "Deduction Descriptions",
    date: "Date",
    amount: "Amount",
    gross: "%Gross",
    contractorAmount: "Contractor Amount",
  };
  const deductionTableData = deductionArrays.flatMap((innerArray) =>
    innerArray.map((item) => ({
      deductionDescription: item.description,
      date: item.statement_date,
      amount: `$${item.amount.toLocaleString("en-US", {
        maximumFractionDigits: 2,
      })}`,
      gross: `${item.gross_percentage}%`,
      contractorAmount: `$${item.contractor_amount.toLocaleString("en-US", {
        maximumFractionDigits: 2,
      })}`,
    }))
  );
  const deductionDescriptionTableData = deductionArrays.flatMap((innerArray) =>
    innerArray.map((item) => ({
      id: item._id,
      deductionDescription: item.description,
      amount: `${item.contractor_amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
    }))
  );
  // Calculate the subtotal
  const subtotalDeductions = deductionArrays
    .flat()
    .reduce((total, item) => total + item.contractor_amount, 0);

  // Append the "Sub Total" row
  // deductionTableData.push({
  //   deductionDescription: "",
  //   date: "", // Use the formatted date here
  //   amount: "",
  //   grossPercenatge: "Sub Total",
  //   contractorAmount: `$${subtotalDeductions.toLocaleString("en-US", {
  //     maximumFractionDigits: 2,
  //   })}`,
  // });
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };
  const handleRowClick = (rowIndex, driverId) => {
    console.log("ClickedrowIndex");
    console.log("ClickedrowIndex1", rowIndex);
    const clickedRowData = loadSubTableData[rowIndex];
    console.log("ClickedrowIndex2", rowIndex);
    setLoadDetailsTableDataNew(clickedRowData);
  };
  useEffect(() => {
    const calculateMaxTableHeight = () => {
      // Get the window height
      const windowHeight = window.innerHeight;
      // Calculate the available height by subtracting the height of other elements if necessary
      const availableHeight =
        windowHeight - 332; /* subtract other elements height */
      // Set the max height of the table container
      setMaxTableHeight(availableHeight);
    };

    // Call the function initially and on window resize
    calculateMaxTableHeight();
    window.addEventListener("resize", calculateMaxTableHeight);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", calculateMaxTableHeight);
    };
  }, []);
  console.log("ClickedrowIndex2", loadDetailsTableDataNew);
  useEffect(() => {
    // Find the index of the driver object with matching driver_id
    const driverIndex = settlementsTableDataALL.findIndex(
      (driver) => driver.driverID === driverID
    );
    console.log("driverIndex", driverIndex);

    // Check if the driver was found
    if (driverIndex !== -1) {
      // Driver found, use the index
      console.log("Index of the driver:", driverIndex);
      setCurrentDriverIndex(driverIndex);
    } else {
      // Driver not found
      console.log("Driver not found.");
    }
  }, [driverID, settlementsTableDataALL]);
  // Function to handle click on next arrow
  const handleNextArrowClick = () => {
    if (currentDriverIndex < settlementsTableDataALL.length - 1) {
      setCurrentDriverIndex((prevIndex) => prevIndex + 1);
      const nextDriverID =
        settlementsTableDataALL[currentDriverIndex + 1].driverID;
      console.log("nextDriverID", nextDriverID);
      getSettelmentDriverDetailsDataAPI(nextDriverID);
      history.push(`/settlement/${settlementDate}/${uploadId}/${nextDriverID}`);
    }
  };

  // Function to handle click on previous arrow
  const handlePreviousArrowClick = () => {
    if (currentDriverIndex > 0) {
      setCurrentDriverIndex((prevIndex) => prevIndex - 1);
      const previousDriverID =
        settlementsTableDataALL[currentDriverIndex - 1].driverID;
      getSettelmentDriverDetailsDataAPI(previousDriverID);
      history.push(
        `/settlement/${settlementDate}/${uploadId}/${previousDriverID}`
      );
    }
  };
  console.log("newDriverID", newDriverID);
  useEffect(() => {
    handleReturnSettlementsDriversPOC();
    const originalDateString = settlementDate ? settlementDate : "";
    let originalDate = moment.utc(originalDateString);
    const month = moment(originalDate).format("MMM");
    const day = moment(originalDate).format("DD");
    const year = moment(originalDate).year();
    const formattedDate = `${month} ${day}, ${year}`;
    console.log("setStatementDate1", formattedDate);
    setStatementDate(formattedDate);
    if (uploadId > 0) {
      getSettlementsListDataAPI();
      getSettelmentDriverDetailsDataAPI();
    }
  }, [uploadId]);
  const getSettlementsListDataAPI = () => {
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/settlements/${uploadId}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getSettlementsListData(uploadId)
      .then((response) => {
        //console.log("insideif", response);
        console.log("getSettlementsListData", response.data);
        setSettlementsListOriginalData(response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const getSettelmentDriverDetailsDataAPI = (id = driverID) => {
    const storedToken = localStorage.getItem("token");
    // fetch(
    //   `https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1/admin/settlements/${uploadId}/${id}`,
    //   {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${storedToken}`,
    //     },
    //   }
    // )
    //   .then((result) => {
    //     if (result.status === 200) {
    //       return result.json();
    //     } else {
    //       alert("Please check login credentials!");
    //     }
    //   })
    getSettelmentDriverDetailsData(uploadId, id)
      .then((response) => {
        //console.log("insideif", response);
        console.log("getSettelmentDriverDetailsDataAPI", response.data);
        setSettelmentsDriverDetailsOriginalData(
          response.data ? response.data : ""
        );
        const name = response.data[0].driver_name
          ? response.data[0].driver_name
          : "";
        const newName = name.split(", ").reverse().join(" ");
        setDriverName(newName);
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  const [
    currentPageSettlementsDriversPOC,
    setCurrentPageSettlementsDriversPOC,
  ] = useState(1);
  const [
    itemsPerPageSettlementsDriversPOC,
    setItemsPerPageSettlementsDriversPOC,
  ] = useState(50);
  const handlePageChange = (pageNumber) => {
    setCurrentPageSettlementsDriversPOC(pageNumber);
  };
  const handleItemsPerPageChange = (perPage) => {
    setItemsPerPageSettlementsDriversPOC(perPage);
    setCurrentPageSettlementsDriversPOC(1); // Reset to the first page when changing items per page
  };
  const handleNavigateAway = () => {
    // Save current page and items per page
    // You can save these values to local storage or any other persistent storage
    localStorage.setItem(
      "currentPageSettlementsDriversPOC",
      currentPageSettlementsDriversPOC
    );
    // localStorage.setItem(
    //   "itemsPerPageSettlementsDriversPOC",
    //   itemsPerPageSettlementsDriversPOC
    // );
  };
  const handleReturnSettlementsDriversPOC = () => {
    // Retrieve saved page and items per page
    const savedPage = localStorage.getItem("currentPageSettlementsDriversPOC");
    // const savedItemsPerPage = localStorage.getItem(
    //   "itemsPerPageSettlementsDriversPOC"
    // );
    setCurrentPageSettlementsDriversPOC(savedPage ? parseInt(savedPage) : 1);
    // setItemsPerPageSettlementsDriversPOC(
    //   savedItemsPerPage ? parseInt(savedItemsPerPage) : 50
    // );
  };
  return (
    <React.Fragment>
      <div className="settelmentsDriverPOC">
        <Container fluid>
          <div className=" ">
            <Row xl={12} md={12} sm={12} xs={12}>
              <Col xl={12} md={12} sm={12} xs={12}>
                <div className="detailsStickyHeaderSettlementsDriverDetails">
                  <Breadcrumbs items={breadcrumbItems} />
                  <div style={{ marginTop: "8px" }}>
                    <Title name={statementDate} type={"page"} />
                  </div>
                  <div className="serialNumbersSettlements">
                    <div className="settlementId">Settlement Id:</div>
                    <div className="settlementValue">{uploadId}</div>
                  </div>
                  <div className="tableTitleContainerSettlementsDriver">
                    {" "}
                    <div style={{ flex: "1" }}>
                      <Title
                        name={driverName}
                        type={"page"}
                        fontSize={"22px"}
                      />
                    </div>
                    <div
                      style={{ flex: " " }}
                      className="nextPreviousContainer"
                    >
                      <Icon
                        size="regular"
                        buttonType="secondary"
                        image={
                          currentDriverIndex == 0
                            ? previousGreyArrow
                            : previousArrow
                        }
                        onClick={handlePreviousArrowClick}
                        disabled={currentDriverIndex == 0}
                      ></Icon>
                      <Icon
                        size="regular"
                        buttonType="secondary"
                        image={
                          currentDriverIndex ==
                          settlementsTableDataALL.length - 1
                            ? nextGreyArrow
                            : nextArrow
                        }
                        onClick={handleNextArrowClick}
                        disabled={
                          currentDriverIndex ==
                          settlementsTableDataALL.length - 1
                        }
                      ></Icon>
                    </div>
                  </div>
                </div>
                <div className="tableContainerSettlementsDriver">
                  <div className="driversTableContainerSettlementsDriver">
                    <DriversTablePOC
                      headers={settlementsTableHeaders}
                      //data={settlementsTableDataALL}
                      data={settlementsTableDataAPI}
                      activeTab={activeTab}
                      tableName={"settelmentsDriverTablePOC"}
                      currentPage={currentPageSettlementsDriversPOC}
                      itemsPerPage={itemsPerPageSettlementsDriversPOC}
                      onPageChange={handlePageChange}
                      onItemsPerPageChange={handleItemsPerPageChange}
                      onNavigateAway={handleNavigateAway}
                    />
                  </div>
                  <div
                    className="settlementsTableDetailsConatainer"
                    style={{
                      maxHeight: `${maxTableHeight}px`,
                      //marginTop: "16px",
                      paddingTop: "0",
                    }}
                  >
                    <div
                      style={{ background: "#fff", marginTop: "16px" }}
                      className="loadTable"
                    >
                      <DriversTablePOC
                        headers={loadsTableHeaders}
                        data={loadsTableData}
                        subHeaders={loadDetailsTableHeaders}
                        subData={loadDetailsTableDataNew}
                        activeTab={activeTab}
                        tableName={"loadsSettelmentsTable"}
                        rowClick={true}
                        rowClickHandler={handleRowClick}
                        currentPage={currentPageSettlementsDriversPOC}
                        itemsPerPage={itemsPerPageSettlementsDriversPOC}
                        onPageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                        onNavigateAway={handleNavigateAway}
                      />
                    </div>
                    <div
                      style={{ background: "#ffffff" }}
                      className="loadTable"
                    >
                      {/* <DriversTablePOC
                        headers={additionalPaymentTableHeaders}
                        data={additionalPaymentTableData}
                        activeTab={activeTab}
                        tableName={"additionalPaymentTable"}
                      /> */}
                      <AdditionalPaymentTable
                        headers={additionalPaymentTableHeaders}
                        data={additionalPaymentDescriptionTableData}
                        tableName={"additionalPaymentTable"}
                        uploadId={uploadId}
                        driverId={driverID}
                      />
                    </div>
                    <div
                      style={{ background: "#ffffff" }}
                      className="loadTable"
                    >
                      {/* <DriversTablePOC
                        headers={deductionDescriptionTableHeaders}
                        data={deductionTableData}
                        activeTab={activeTab}
                        tableName={"deductionDescriptionTable"}
                      /> */}
                      <AdditionalPaymentTable
                        headers={deductionDescriptionTableHeaders}
                        data={deductionDescriptionTableData}
                        tableName={"deductionDescriptionTable"}
                        uploadId={uploadId}
                        driverId={driverID}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default SettlementsDriverPOC;
